/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Input,
  Space,
  Dropdown,
  Menu,
  Spin,
  Pagination,
  Select,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import CommonTable from "../../commonComponents/Table/table";
import useLogout from "../../hooks/useLogout";
import {
  fetchAllTasks,
  useFetchCompanyCode,
  useFetchTask,
} from "../../hooks/useTasks";
import moment from "moment";
import { debounce } from "lodash";
import SpinLoader from "../../commonComponents/SpinLoader";
import stc from "string-to-color";

const Dashboard = () => {
  const [tableData, setTableData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [dropDownText, setDropDownText] = useState("");
  const [companyCodeText, setCompanyCodeText] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const debouncedFunc = useRef();
  const navigate = useNavigate();
  const { logout } = useLogout();

  const { data: taskDropdownList, isLoading, isError } = useFetchTask();
  const FetchCompanyCodeError = (err) => {
    if (err.response.status === 401) logout();
  };
  const { data: companyCodeList } = useFetchCompanyCode(FetchCompanyCodeError);

  const onSuccess = (data) => {
    setLoading(false);
    setTableData(data?.data?.data);
  };

  // const pageSize = 10;
  const {
    refetch: fetchTaskData,
    data,
    dataUpdatedAt,
    isFetching,
  } = useQuery(
    [
      "listing",
      searchText,
      pageNumber,
      pageSize,
      companyCodeText,
      dropDownText,
    ],
    fetchAllTasks,
    {
      enabled: false,
      onSuccess,
    }
  );

  let lastFetchTime = moment(dataUpdatedAt).format("h:mm:ss a");

  useEffect(() => {
    if (searchText) {
      setLoading(true);
      setPageNumber(1);
      debouncedFunc.current();
      console.log("search text")
    } else {
      fetchTaskData();
    }
  }, [searchText]);

  useEffect(() => {
    setLoading(true);
    fetchTaskData();
    debouncedFunc.current = debounce(() => {
      fetchTaskData();
      console.log("search text")
    }, 2000);
  }, [companyCodeText, dropDownText, pageNumber, pageSize]);

  const navToBookingDetails = (id) => {
    navigate("/bookingDetails", {
      state: {
        orderId: id,
      },
    });
  };

  const renderActionbtn = (data) => {
    if (data.taskType === "AssignStudio") {
      return (
        <Button onClick={() => navToBookingDetails(data.oid)}>
          Assign Studio
        </Button>
      );
    } else if (data.taskType === "TagData") {
      return (
        <Button>
          <a
            href="https://flixtag.flixstock.com"
            target="_blank"
            rel="noreferrer"
          >
            Go To FlixTag
          </a>
        </Button>
      );
    } else if (data.taskType === "Assignment") {
      return (
        <Button>
          <a
            href="https://styling.flixstock.com"
            target="_blank"
            rel="noreferrer"
          >
            Go To FlixStyling
          </a>
        </Button>
      );
    } else if (data.taskType === "PII") {
      return (
        <Button>
          <a
            href="https://piiportal.flixstock.com"
            target="_blank"
            rel="noreferrer"
          >
            Go To PII Portal
          </a>
        </Button>
      );
    } else if (data.taskType === "Shoot") {
      return (
        <Button>
          <a
            href="https://studioapp.flixstock.com"
            target="_blank"
            rel="noreferrer"
          >
            Go To Studio Portal
          </a>
        </Button>
      );
    } else if (data.taskType === "DDApproval") {
      const DDhref = `https://master.d2aa62ygg90qvn.amplifyapp.com?id=${data.oid}`;
      return (
        <Button>
          <a href={DDhref} target="_blank" rel="noreferrer">
            Show DD
          </a>
        </Button>
      );
    } else if (data.taskType === "RawQC") {
      return (
        <Button>
          <a
            href="https://rawqc.flixstock.com"
            target="_blank"
            rel="noreferrer"
          >
            Go To RawQC
          </a>
        </Button>
      );
    }
  };

  const dropdownFilter = () => {
    setPageNumber(1);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, record) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              flexDirection: "row",
            }}
          >
            <div
              style={{
                backgroundColor: stc(record?.companyCode),
                width: "10px",
                height: "50px",
                // border: "1px solid #000",
                marginRight: "15px",
              }}
            ></div>
            <span>
              <b>{record?.name}</b>
            </span>
          </div>
        );
      },
    },
    {
      title: "Company Code",
      dataIndex: "companyCode",
      keyName: "companyCode",
    },
    {
      title: "Current Status",
      dataIndex: "currentStatus",
      key: "currentStatus",
    },
    {
      title: "Task Type",
      dataIndex: "taskType",
      key: "taskType",
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => renderActionbtn(record),
    },
  ];

  if (isError) {
    logout();
  }

  const handleSearch = (e) => {
    let newValue = e.target.value;
    setSearchText(newValue);
  };

  // const spinIcon = (
  //   <div className="spin-center">
  //     <Spin className="spin_loader" size="large" />{" "}
  //   </div>
  // );

  const resetFilter = () => {
    setDropDownText("");
    setCompanyCodeText("");
    setSearchText("");
    setTableData(data?.data?.data);
    setPageNumber(1);
    setLoading(true);
    fetchTaskData();
  };

  const fetchNextData = (pageNum) => {
    let pageNo = pageNum++;
    setPageNumber(pageNo);
  };
  const oncompanyCodeChange = (value) => {
    setCompanyCodeText(value);
    dropdownFilter();
  };

  const onTaskTypeChange = (value) => {
    setDropDownText(value);
    dropdownFilter();
  };

  return (
    <>
      <div
        style={{
          textAlign: "end",
          fontSize: "12px",
          fontWeight: "600",
          height: "60px",
        }}
        className="dashboard_header"
      >
        <div
          className="d-flex"
          style={{
            justifyContent: "space-between",
          }}
        >
          <span className="span-font-size">Dashboard : </span>
          <span className="span-font-size">
            Last data updated at :<span>{lastFetchTime}</span>
          </span>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "space-between",
        }}
      >
        <div>
          <span
            style={{
              fontSize: "13px",
              fontWeight: "600",
            }}
          >
            Filter by company code
          </span>
          <Select
            placeholder="Select company code"
            onChange={(text) => oncompanyCodeChange(text)}
            className="filter_dropdown"
            value={companyCodeText}
          >
            <Select.Option key="none" value={""}>
              All
            </Select.Option>
            {companyCodeList?.map((el) => {
              return (
                <Select.Option key={el.id} value={el}>
                  {el}
                </Select.Option>
              );
            })}
          </Select>
        </div>
        <div>
          <span
            style={{
              fontSize: "13px",
              fontWeight: "600",
            }}
          >
            Filter by task type
          </span>
          <Select
            placeholder="Select company code"
            onChange={(text) => onTaskTypeChange(text)}
            className="filter_dropdown"
            value={dropDownText}
          >
            <Select.Option key="none" value={""}>
              All
            </Select.Option>
            {taskDropdownList?.map((el) => {
              return (
                <Select.Option key={el.id} value={el}>
                  {el}
                </Select.Option>
              );
            })}
          </Select>
        </div>
        <div
          style={{
            width: "15%",
          }}
        >
          <Input
            value={searchText}
            placeholder="Search"
            name="search"
            onChange={handleSearch}
          />
        </div>
        <Button onClick={resetFilter}>Reset Filters</Button>
      </div>
      <hr
        style={{
          width: "100%",
          margin: "10px 0",
          color: "#e8e8e8",
        }}
      />
      <div
        style={{
          height: "calc(100% - 220px)",
          marginTop: "60px",
          overflow: "auto",
        }}
      >
        <CommonTable
          columns={columns}
          data={tableData}
          bordered
          loading={{
            spinning: isFetching,
            indicator: <SpinLoader />,
          }}
          size="small"
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          paddingTop: "1rem",
          height: "50px",
        }}
      >
        <Pagination
          // defaultCurrent={1}
          current={pageNumber}
          total={data?.data?.totalCount}
          onChange={(page) => fetchNextData(page)}
          // showSizeChanger={false}
          pageSizeOptions={["10", "20", "50"]}
          // total={orderData?.data?.totalCount}
          pageSize={pageSize}
          defaultPageSize={pageSize}
          showSizeChanger
          onShowSizeChange={(current, size) => {
            setPageSize(size);
            setPageNumber(1);
          }}
        />
      </div>
    </>
  );
};

export default Dashboard;
